import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppEmbedService } from '../services/app-embed.service';
import { AuthService } from '../services/auth.service';
import { IdbStorageService } from '../services/storage/idb-storage.service';
import { storageDict } from '../services/storage/storage-dict';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private storage: IdbStorageService,
    private authService: AuthService,
    private appEmbedService: AppEmbedService,
    private router: Router
  ) {}

  canActivate(
    _: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.appEmbedService.embedRequestData) {
      const { redirectId, redirectUrl } = this.appEmbedService.embedRequestData;
      if (redirectId && redirectUrl) {
        return this.authService.authState$.pipe(
          map((res) => {
            return res === true;
          })
        );
      }
    }

    const credentials$ = forkJoin([
      this.storage.getItemSync(storageDict.authLocalStorageToken),
      this.storage.getItemSync(storageDict.refreshToken),
      this.storage.getItemSync(storageDict.karyawan),
    ]);

    return credentials$.pipe(
      map((auth) => {
        if (auth[0] && auth[1] && auth[2]) {
          return true;
        } else {
          this.authService.changeAuthState(false);
          localStorage.clear();
          this.storage.clear();
          this.router.navigate(['/auth/login'], {
            queryParams: {
              target: state.url !== '/dashboard' ? state.url : undefined,
            },
          });
          return false;
        }
      })
    );
  }
}
